<template>
  <el-card class="h-full" v-loading="pageLoading" :body-style="{ padding: '20px', height: '100%' }">
    <el-row class="w-full h-36px">
      <div class="float-right">
        <el-button
          type="primary"
          size="small"
          v-if="editType !== 'read'"
          @click="handleEdit('agree')"
          >通过</el-button
        >
        <el-button
          type="danger"
          size="small"
          v-if="editType !== 'read'"
          @click="handleEdit('refuse')"
          >拒绝</el-button
        >
        <el-button type="primary" size="small" @click="goApiDetail()">详情</el-button>
        <el-button size="small" @click="$router.go(-1)">返回</el-button>
      </div>
    </el-row>
    <el-row :gutter="10" class="mt-20px">
      <el-form :model="applyForm" ref="applyForm" label-width="150px">
        <el-col :span="8">
          <el-form-item :label="$t('申请部门')" prop="applyDepartment">
            <el-input
              size="small"
              :placeholder="$t('请输入申请部门')"
              readonly
              v-model="applyForm.applyDepartment"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('申请应用')" prop="name">
            <el-input
              size="small"
              :placeholder="$t('请输入申请应用')"
              readonly
              v-model="applyForm.name"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('申请人')" prop="applyUser">
            <el-input
              size="small"
              :placeholder="$t('请输入申请人')"
              readonly
              :value="computeData(applyForm.applyUser, userList, 'user')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('申请描述')" prop="description">
            <el-input
              readonly
              size="small"
              type="textarea"
              :placeholder="$t('申请用途描述')"
              v-model="applyForm.description"
            />
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <el-card style="height: calc(100% - 180px)" :body-style="{ height: '100%' }">
      <el-row :gutter="10" class="p-10px">
        <el-form :model="applyApiForm" ref="applyForm" label-width="150px">
          <el-col :span="8">
            <el-form-item :label="$t('API名称')" prop="name">
              <el-input
                size="small"
                :placeholder="$t('请输入API名称')"
                readonly
                v-model="applyApiForm.name"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('API代码')" prop="code">
              <el-input
                size="small"
                :placeholder="$t('请输入API代码')"
                readonly
                v-model="applyApiForm.code"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('地址')" prop="address">
              <el-input
                size="small"
                readonly
                :placeholder="$t('请以openapi开头')"
                v-model="applyApiForm.address"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('描述')" prop="description">
              <el-input
                size="small"
                readonly
                type="textarea"
                :placeholder="$t('API简要描述')"
                v-model="applyApiForm.description"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('调用建议')" prop="propose">
              <el-input
                size="small"
                readonly
                type="textarea"
                :placeholder="$t('API调用建议')"
                v-model="applyApiForm.propose"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('使用场景')" prop="usageScene">
              <el-input
                size="small"
                type="textarea"
                readonly
                :placeholder="$t('API使用场景说明')"
                v-model="applyApiForm.usageScene"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('API类型')" prop="type">
              <template>
                <el-select
                  class="w-full"
                  v-model="applyApiForm.type"
                  filterable
                  disabled
                  allow-create
                  clearable
                  size="small"
                >
                  <el-option
                    v-for="(item, index) in apiTypes"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('请求方式')" prop="method" class="w-full">
              <el-select
                class="w-full"
                v-model="applyApiForm.method"
                filterable
                disabled
                clearable
                size="small"
              >
                <template v-if="!_.isEmpty(apiMethods)">
                  <el-option
                    v-for="(item, index) in apiMethods"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <el-row style="height: calc(100% - 231px)">
        <div class="mb-10px flex items-center text-14px">
          <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">输入</span>
        </div>
        <el-table border class :data="inputData" height="calc(50% - 28px)">
          <el-table-column label="参数代码" prop="code">
            <template slot-scope="scope">
              <el-input
                size="small"
                :readOnly="editType === 'read'"
                v-model="scope.row.code"
                :placeholder="$t('请输入参数代码')"
              />
            </template>
          </el-table-column>
          <el-table-column label="参数名称" prop="name">
            <template slot-scope="scope">
              <el-input
                size="small"
                :readOnly="editType === 'read'"
                v-model="scope.row.name"
                :placeholder="$t('请输入参数名称')"
              />
            </template>
          </el-table-column>
          <el-table-column label="数据类型" prop="type">
            <template slot-scope="scope">
              <el-select
                :disabled="editType === 'read'"
                filterable
                clearable
                v-model="scope.row.type"
                class="!w-full"
              >
                <el-option
                  v-for="(item, index) in dataTypes"
                  :label="item.label"
                  :value="item.value"
                  :key="index"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="查询方式" prop="queryMode">
            <template slot-scope="scope">
              <el-select
                :disabled="editType === 'read'"
                filterable
                clearable
                v-model="scope.row.queryMode"
                class="!w-full"
              >
                <el-option
                  v-for="(item, index) in queryModes"
                  :label="item.label"
                  :value="item.value"
                  :key="index"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
        <div class="mb-10px mt-10px flex items-center text-14px">
          <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">输出</span>
        </div>
        <el-table border class :data="outPutData" height="calc(50% - 28px)">
          <el-table-column label="参数代码" prop="code">
            <template slot-scope="scope">
              <el-input
                size="small"
                :readOnly="editType === 'read'"
                v-model="scope.row.code"
                :placeholder="$t('请输入参数代码')"
              />
            </template>
          </el-table-column>
          <el-table-column label="参数名称" prop="name">
            <template slot-scope="scope">
              <el-input
                size="small"
                :readOnly="editType === 'read'"
                v-model="scope.row.name"
                :placeholder="$t('请输入参数名称')"
              />
            </template>
          </el-table-column>
          <el-table-column label="数据类型" prop="type">
            <template slot-scope="scope">
              <el-select
                :disabled="editType === 'read'"
                filterable
                clearable
                v-model="scope.row.type"
                class="!w-full"
              >
                <el-option
                  v-for="(item, index) in dataTypes"
                  :label="item.label"
                  :value="item.value"
                  :key="index"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-card>
  </el-card>
</template>
<script>
import { ApplyApplicationApi, OpenApiApi } from '@wiz-api/open-api-management'

const applyApplicationApi = new ApplyApplicationApi()
const openApiApi = new OpenApiApi()
export default {
  name: 'apiExamine',
  components: {},
  data() {
    return {
      pageLoading: false,
      editType: 'examine',
      applyForm: {
        applyDepartment: '',
        name: '',
        applyUser: '',
        description: '',
      },
      tableData: [],
      applyApiForm: {
        name: '', // api名称
        code: '',
        type: '', // api类型
        address: '', // 地址
        description: '', // 描述
        propose: '', // 调用建议
        usageScene: '', // 使用场景
        method: '', // 请求方式
      },
      entityTypes: [],
      apiMethods: [],
      apiTypes: [],
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      userList: [],
      paramTypes: [],
      inputData: [],
      outPutData: [],
      dataTypes: [],
      queryModes: [],
    }
  },
  watch: {},
  computed: {
    tableHeighht() {
      return `${window.innerHeight - 590}px`
    },
    organizationList() {
      return this.$store.getters['System/organizationList']
    },
  },
  methods: {
    /**
     * @function 获取角色
     */
    async getCharactor() {
      const fileServer = Wiz.GetModuleServer('system-management')
      const res = await axios.get(
        `${fileServer}/api/eaf-user-role/get-users?SkipCount=0&MaxResultCount=999`
      )
      if (res && res.data && res.status === 200) {
        this.userList = res.data.items
      }
    },
    computeData(value, dataList, type) {
      const currentRow = _.find(dataList, ['id', value])
      if (type === 'user') {
        return currentRow ? currentRow.name : value
      }
      return currentRow ? currentRow.name : value
    },
    goApiDetail() {
      const currentOne = _.find(this.applyForm.applyOpenApiRecords, [
        'openApiId',
        this.$route.query.apiId,
      ])
      if (!_.isEmpty(currentOne) && currentOne.auditStatus === 2) {
        // 通过
        this.$router.push(
          `./api-release-create?id=${this.$route.query.apiId}&type=read&token=${this.applyForm.token}`
        )
        return
      }
      this.$router.push(`./api-release-create?id=${this.$route.query.apiId}&type=read`)
    },
    handleEdit(type) {
      const text = type === 'agree' ? '通过' : '拒绝'
      this.$confirm(`确认要${text}么`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const reqData = {
            applyOpenApiRecordIds: [this.$route.query.id],
            isPass: type === 'agree',
          }
          const [err, res] = await applyApplicationApi.approveApplyOpenApi({ body: reqData })
          if (!err) {
            this.editType = 'read'
            this.$message.success(`已${text}`)
            this.findDetail(this.$route.query.applicationId)
          }
        })
        .catch(() => {
          this.$message.info('取消操作')
        })
    },
    async findDetail(id) {
      const [err, res] = await applyApplicationApi.get(id)
      if (!err) {
        const currentOne = _.find(res.applyOpenApiRecords, ['id', this.$route.query.id])
        if (!_.isEmpty(currentOne) && currentOne.auditStatus > 2) {
          this.editType = 'read'
        }
        this.applyForm = res
      }
    },
    async findApiDetail(id) {
      const [err, res] = await openApiApi.get(id)
      if (!err) {
        this.applyApiForm = res
        _.map(this.paramTypes, (item) => {
          if (item.item2 === '输入参数') {
            this.inputData = _.filter(res.openApiParamSettings, (iItem) => {
              return iItem.paramType === item.item1
            })
          }
          if (item.item2 === '输出参数') {
            this.outPutData = _.filter(res.openApiParamSettings, (oItem) => {
              return oItem.paramType === item.item1
            })
          }
        })
      }
    },
    async findApiMethod() {
      const [err, res] = await openApiApi.getAllowedRequestMethods()
      if (!err) {
        this.apiMethods = _.map(res, (item) => {
          return {
            label: item.item2,
            value: item.item1,
          }
        })
      }
    },
    async findApiType() {
      const [err, res] = await openApiApi.getDistinctApiType()
      if (!err) {
        this.apiTypes = _.map(res, (item) => {
          return {
            label: item,
            value: item,
          }
        })
      }
    },
    // 获取参数类型（输入、输出）
    async findParamTypes() {
      const [err, res] = await openApiApi.getParamTypes()
      if (!err) {
        this.paramTypes = res
      }
    },
    // 数据类型
    async findDataType() {
      const [err, res] = await openApiApi.getParamValueTypes()
      if (!err) {
        this.dataTypes = _.map(res, (item) => {
          return {
            label: item.item2,
            value: item.item1,
          }
        })
      }
    },
    // 查询方式
    async findQueryMode() {
      const [err, res] = await openApiApi.getParamQueryModes()
      if (!err) {
        this.queryModes = _.map(res, (item) => {
          return {
            label: item.item2,
            value: item.item1,
          }
        })
      }
    },
  },
  async created() {
    // 获取用户角色
    this.getCharactor()
    this.pageLoading = true
    this.editType = this.$route.query.type
    // 获取请求方式
    await this.findApiMethod()
    // 获取API类型
    await this.findApiType()
    // 获取参数类型（输入、输出）
    await this.findParamTypes()
    // 获取数据类型
    await this.findDataType()
    // 获取查询方式
    await this.findQueryMode()
    await this.findDetail(this.$route.query.applicationId)
    await this.findApiDetail(this.$route.query.apiId)
    this.pageLoading = false
  },
  mounted() {},
}
</script>
